/**
 * Compliance review API client (TASK-583).
 * Reads a client's latest document-based FinSA/FINMA/AML review (the reborn
 * compliance-agent, now the in-process review_compliance skill). Feeds the
 * ComplianceCockpit / ComplianceReview canvas widgets.
 *
 * Read-only: generation goes through the KAH review_compliance tool / brief path,
 * not this service. httpClient injects auth + X-Account-ID (RLS).
 */
import { httpClient } from '../../lib/httpClient';

export interface ComplianceRegulationChecked {
  id: string;
  name: string;
  score: number | null;
}

export interface ComplianceReviewData {
  compliance_review: string;
  // null = not scored (no rules ran). NEVER render null as a green pass.
  compliance_score: number | null;
  violations_found: string[];
  recommendations: string[];
  compliance_outcome: string | null; // validated | issues_found | review_generated
  compliance_outlook: string;
  regulatory_intelligence: {
    regulations_checked?: ComplianceRegulationChecked[];
    violations?: string[];
    regulatory_score?: number | null;
  } | null;
  generated_at: string | null;
}

export interface ComplianceReviewLatest {
  client_id: string;
  status?: 'ready' | 'empty';
  review: ComplianceReviewData | null;
}

export const complianceApiService = {
  async getLatestComplianceReview(clientId: string): Promise<ComplianceReviewLatest> {
    return httpClient.get<ComplianceReviewLatest>(
      `/api/compliance-review/client/${encodeURIComponent(clientId)}/latest`,
    );
  },
};

export default complianceApiService;
